<template>
  <b-modal
    id="add-branch-modal"
    v-model="addBranchModal"
    dialog-class="add-branch-modal"
    body-class="pb-2"
    cancel-variant="secondary"
    size="md"
    centered
    hide-footer
    :title="$t('branch.add-new-branch')"
    lazy
  >
    <error-alert :error="error" />

    <div>
      <div>
        <div class="font-weight-bold mb-1 text-secondary">
          {{ $t('branch.add-branch-question') }}
        </div>
        <div>
          <select-add-branch-method
            v-model="createMethod"
            :branch-id.sync="clonedBranchId"
            :clone-text="$t('branch.take-copy')"
            :create-text="$t('branch.create-empty')"
          />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-2">
      <b-button
        size="lg"
        variant="dark"
        @click="handleAddBranch"
      >
        <b-spinner
          v-if="creating"
          small
        />
        <span v-else>
          {{ $t('forms.add') }}
        </span>
      </b-button>
    </div>

    <upgrade-modal
      v-model="upgradeModal"
      feature="branch.branch"
      feature-slug="branch"
      :limit="$store.getters['subscription/branchesLimit']"
    />
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import SelectAddBranchMethod from '@/@okmenu/components/modals/branches/SelectAddBranchMethod'
import AddBranchMixin from '@/mixins/add-branch-mixin'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import UpgradeModal from '@/views/admin/purchase/components/UpgradeModal'

export default {
  name: 'AddBranchModal',
  components: {
    UpgradeModal,
    ErrorAlert,
    SelectAddBranchMethod,
    BModal,
    BButton,
    BSpinner,
  },
  mixins: [AddBranchMixin],
  data() {
    return {
      creating: false,
      error: null,
      upgradeModal: false,
    }
  },
  methods: {
    handleAddBranch() {
      if (this.$store.getters['subscription/branchesLimit'] <= this.$store.getters['branches/branches'].length) {
        this.upgradeModal = true
        return
      }

      this.creating = true
      this.error = null

      this.addBranch()
        .then(() => { this.addBranchModal = false })
        .catch(error => { this.error = error })
        .finally(() => { this.creating = false })
    },
  },
}
</script>
